// QRCodeCanvas.tsx
import { useEffect, useRef } from "react";
import QRCode from "qrcode";
import { MULTIPLAYER, WaitingRoomConstants } from "../../utils/constants";

interface QRCodeCanvasProps {
    lobbyId: string | null;
    id?: string | undefined; // id for styles
}

/* Creates a QR code for the game URL */
export function QRCodeCanvas({ lobbyId, id }: QRCodeCanvasProps) {
    const canvasRef = useRef<HTMLCanvasElement>(null);

    useEffect(() => {
        if (!lobbyId || !canvasRef.current) return;

        const multiplayerGameLobbyURL = new URL(window.location.origin);
        multiplayerGameLobbyURL.searchParams.set(MULTIPLAYER.LOBBY_ID_KEY, lobbyId);

        console.log(multiplayerGameLobbyURL.toString());

        QRCode.toCanvas(
            canvasRef.current,
            multiplayerGameLobbyURL.toString(),
            WaitingRoomConstants.QR_CODE_CONFIG,
            (error) => {
                if (error) {
                    console.error("[QRCodeCanvas] QR Code generation failed:", error);
                }
            },
        );
    }, [lobbyId]);

    return <canvas ref={canvasRef} id={id} />;
}
